import {
  DELUXE_KING,
  STANDARD_KING,
  DELUXE_QUEEN,
  STANDARD_QUEEN,
  ULTRA_KING,
  CORNER_SUITE,
  PLATINUM_SUITE,
  PROPERTY_ATMORE,
  PROPERTY_MONTGOMERY,
  PROPERTY_WETUMPKA,
  PROPERTY_BETHLEHEM,
  PROPERTY_CHICAGO,
  CHAIRMAN_SUITE,
  EXECUTIVE_SUITE,
  PRESIDENTIAL_SUITE,
  SUITE_KING,
  WCB_TOWER_2_ROOM_TYPE_CODES,
  GRAND_EXECUTIVE_SUITE,
  GRAND_KING,
  ACCESSIBLE_FABULOUS_SUITE,
  ACCESSIBLE_QUEEN,
  ACCESSIBLE_KING,
  ACCESSIBLE_EXECUTIVE_SUITE,
  FABULOUS_SUITE,
  FANTASY_SUITE,
  ACCESSIBLE_FANTASY_SUITE
} from 'utils/constants';
import mapValues from 'lodash/mapValues';

const atmoreCornerSuite1 = 'atmore/Corner Suite/1.jpg';
const atmoreCornerSuite2 = 'atmore/Corner Suite/2.jpg';
const atmoreCornerSuite3 = 'atmore/Corner Suite/3.jpg';
const atmoreCornerSuite4 = 'atmore/Corner Suite/4.jpg';
const atmoreCornerSuite5 = 'atmore/Corner Suite/5.jpg';
const atmoreCornerSuite6 = 'atmore/Corner Suite/6.jpg';
const atmoreCornerSuite7 = 'atmore/Corner Suite/7.jpg';
const atmoreCornerSuite8 = 'atmore/Corner Suite/8.jpg';
const atmoreCornerSuite9 = 'atmore/Corner Suite/9.jpg';
const atmoreCornerSuite10 = 'atmore/Corner Suite/10.jpg';
const atmoreCornerSuite11 = 'atmore/Corner Suite/11.jpg';
const atmoreCornerSuite12 = 'atmore/Corner Suite/12.jpg';
const atmoreDeluxeKing1 = 'atmore/Deluxe King/1.jpg';
const atmoreDeluxeKing2 = 'atmore/Deluxe King/2.jpg';
const atmoreDeluxeKing3 = 'atmore/Deluxe King/3.jpg';
const atmoreDeluxeKing4 = 'atmore/Deluxe King/4.jpg';
const atmoreDeluxeKing5 = 'atmore/Deluxe King/5.jpg';
const atmoreDeluxeQueen1 = 'atmore/Deluxe Queen/1.jpg';
const atmoreDeluxeQueen2 = 'atmore/Deluxe Queen/2.jpg';
const atmoreDeluxeQueen3 = 'atmore/Deluxe Queen/3.jpg';
const atmorePlatinumSuite1 = 'atmore/Platinum Suite/1.jpg';
const atmorePlatinumSuite2 = 'atmore/Platinum Suite/2.jpg';
const atmorePlatinumSuite3 = 'atmore/Platinum Suite/3.jpg';
const atmorePlatinumSuite4 = 'atmore/Platinum Suite/4.jpg';
const atmorePlatinumSuite5 = 'atmore/Platinum Suite/5.jpg';
const atmorePlatinumSuite6 = 'atmore/Platinum Suite/6.jpg';
const atmorePlatinumSuite7 = 'atmore/Platinum Suite/7.jpg';
const atmorePlatinumSuite8 = 'atmore/Platinum Suite/8.jpg';
const atmorePlatinumSuite9 = 'atmore/Platinum Suite/9.jpg';
const atmoreUltraKing1 = 'atmore/Ultra King/1.jpg';
const atmoreUltraKing2 = 'atmore/Ultra King/2.jpg';
const atmoreUltraKing3 = 'atmore/Ultra King/3.jpg';
const atmoreUltraKing4 = 'atmore/Ultra King/4.jpg';
const atmoreUltraKing5 = 'atmore/Ultra King/5.jpg';

const bethlehemDeluxeKing1 = 'bethlehem/Deluxe King-min.jpg';
const bethlehemDeluxeKing2 = 'bethlehem/Bathroom-min.jpg';
const bethlehemDeluxeKing3 = 'bethlehem/Bathroom (2)-min.jpg';
const bethlehemDeluxeQueen1 = 'bethlehem/Deluxe Queen-min.jpg';
const bethlehemDeluxeQueen2 = 'bethlehem/Deluxe Queen (2)-min.jpg';
const bethlehemDeluxeQueen3 = 'bethlehem/Bathroom-min.jpg';
const bethlehemDeluxeQueen4 = 'bethlehem/Bathroom (2)-min.jpg';
const bethlehemExecutiveSuite1 = 'bethlehem/Executive Suite Entrance-min.jpg';
const bethlehemExecutiveSuite2 = 'bethlehem/Executive Suite-min.jpg';
const bethlehemExecutiveSuite3 = 'bethlehem/Executive Suite 2-min.jpg';
const bethlehemPresidentialSuite1 = 'bethlehem/Presidential Suite-min.jpg';
const bethlehemPresidentialSuite2 = 'bethlehem/Presidential Bathroom-min.jpg';
const bethlehemChairmanSuite1 = "bethlehem/Chairman's Suite Bedroom-min.jpg";
const bethlehemChairmanSuite2 =
  "bethlehem/Chairman's Suite Living Room-min.jpg";
const bethlehemChairmanSuite3 = "bethlehem/Chairman's Lobby-min.jpg";

const bethlehemTower2DeluxeKing1 = '20230411-Tower_Two-King-031-1920.jpg';
const bethlehemTower2DeluxeKing2 =
  'bethlehem/20230411-Tower_Two-Bathroom-006-1920.jpg';
const bethlehemTower2DeluxeQueen1 =
  'bethlehem/20230411-Tower_Two-Queen-018-1920.jpg';
const bethlehemTower2DeluxeQueen2 =
  'bethlehem/20230411-Tower_Two-Bathroom-006-1920.jpg';

const montgomeryDoubleQueen = 'montgomery/double-queen.jpg';
const montgomeryKing = 'montgomery/king.jpg';
const montgomerySuite1 = 'montgomery/suite-1.jpg';
const montgomerySuite2 = 'montgomery/suite-2.jpg';
const montgomerySuite3 = 'montgomery/suite-3.jpg';
const montgomerySuite4 = 'montgomery/suite-bathroom.jpg';
const montgomerySuite5 = 'montgomery/suite-bedroom.jpg';
const montgomerySuite6 = 'montgomery/suite-living-room.jpg';
const montgomerySuiteKing1 = 'montgomery/suite-king-1-min.jpg';
const montgomerySuiteKing2 = 'montgomery/suite-king-2-min.jpg';
const montgomerySuiteKing3 = 'montgomery/suite-king-3-min.jpg';

const wetumpkaCornerSuite1 = 'wetumpka/Corner Suite/1.jpg';
const wetumpkaCornerSuite2 = 'wetumpka/Corner Suite/2.jpg';
const wetumpkaCornerSuite3 = 'wetumpka/Corner Suite/3.jpg';
const wetumpkaCornerSuite4 = 'wetumpka/Corner Suite/4.jpg';
const wetumpkaCornerSuite5 = 'wetumpka/Corner Suite/5.jpg';
const wetumpkaCornerSuite6 = 'wetumpka/Corner Suite/6.jpg';
const wetumpkaCornerSuite7 = 'wetumpka/Corner Suite/7.jpg';
const wetumpkaDeluxeKing1 = 'wetumpka/Deluxe King/1.jpg';
const wetumpkaDeluxeKing2 = 'wetumpka/Deluxe King/2.jpg';
const wetumpkaDeluxeKing3 = 'wetumpka/Deluxe King/3.jpg';
const wetumpkaDeluxeKing4 = 'wetumpka/Deluxe King/4.jpg';
const wetumpkaDeluxeKing5 = 'wetumpka/Deluxe King/5.jpg';
const wetumpkaDeluxeKing6 = 'wetumpka/Deluxe King/6.jpg';
const wetumpkaDeluxeKing7 = 'wetumpka/Deluxe King/7.jpg';
const wetumpkaDeluxeKing8 = 'wetumpka/Deluxe King/8.jpg';
const wetumpkaDeluxeKing9 = 'wetumpka/Deluxe King/9.jpg';
const wetumpkaDeluxeKing10 = 'wetumpka/Deluxe King/10.jpg';
const wetumpkaDeluxeKing11 = 'wetumpka/Deluxe King/11.jpg';
const wetumpkaDeluxeQueen1 = 'wetumpka/Deluxe Queen/1.jpg';
const wetumpkaDeluxeQueen2 = 'wetumpka/Deluxe Queen/2.jpg';
const wetumpkaDeluxeQueen3 = 'wetumpka/Deluxe Queen/3.jpg';
const wetumpkaDeluxeQueen4 = 'wetumpka/Deluxe Queen/4.jpg';
const wetumpkaDeluxeQueen5 = 'wetumpka/Deluxe Queen/5.jpg';
const wetumpkaDeluxeQueen6 = 'wetumpka/Deluxe Queen/6.jpg';
const wetumpkaPlatinumSuite1 = 'wetumpka/Platinum Suite/1.jpg';
const wetumpkaUltraKing1 = 'wetumpka/Ultra King/1.jpg';
const wetumpkaUltraKing2 = 'wetumpka/Ultra King/2.jpg';
const wetumpkaUltraKing3 = 'wetumpka/Ultra King/3.jpg';
const wetumpkaUltraKing4 = 'wetumpka/Ultra King/4.jpg';
const wetumpkaUltraKing5 = 'wetumpka/Ultra King/5.jpg';
const wetumpkaUltraKing6 = 'wetumpka/Ultra King/6.jpg';
const wetumpkaUltraKing7 = 'wetumpka/Ultra King/7.jpg';
const wetumpkaUltraKing8 = 'wetumpka/Ultra King/8.jpg';
const wetumpkaUltraKing9 = 'wetumpka/Ultra King/9.jpg';
const wetumpkaUltraKing10 = 'wetumpka/Ultra King/10.jpg';
const wetumpkaUltraKing11 = 'wetumpka/Ultra King/11.jpg';
const wetumpkaUltraKing12 = 'wetumpka/Ultra King/12.jpg';
const wetumpkaUltraKing13 = 'wetumpka/Ultra King/13.jpg';
const wetumpkaUltraKing14 = 'wetumpka/Ultra King/14.jpg';
const wetumpkaUltraKing15 = 'wetumpka/Ultra King/15.jpg';
const wetumpkaUltraKing16 = 'wetumpka/Ultra King/16.jpg';
const sliderArcade = 'atmore/confirmation/Slider_Arcade.png';
const sliderBowling = 'atmore/confirmation/Slider_Bowling.png';
const sliderBuffet = 'atmore/confirmation/Slider_Buffet.png';
const sliderCinema = 'atmore/confirmation/Slider_Cinema.png';
const sliderGrill = 'atmore/confirmation/Slider_Grill.png';
const sliderRVPark = 'atmore/confirmation/Slider_RVPark.png';
const sliderYoJoe = 'atmore/confirmation/Slider_YoJoe.png';
const sliderBarber = 'montgomery/confirmation/Slider_Barber.png';
const sliderBBKings = 'montgomery/confirmation/Slider_BBKings.png';
const sliderBBKingsMusic = 'montgomery/confirmation/Slider_BBKings-Music.png';
const sliderFitnessCenter = 'montgomery/confirmation/Slider_FitnessCenter.png';
const sliderLucilles = 'montgomery/confirmation/Slider_Lucilles.png';
const sliderChillyBean = 'wetumpka/confirmation/Slider_ChillyBean.png';
const sliderGrillToGo = 'wetumpka/confirmation/Slider_GrillToGo.png';
const heroFire = 'atmore/confirmation/Hero_Fire.png';
const heroSpa = 'atmore/confirmation/Hero_Spa.png';
const heroIttaBena = 'montgomery/confirmation/Hero_IttaBena.png';
const heroSalon = 'montgomery/confirmation/Hero_Salon.png';
const heroEntertainment = 'wetumpka/confirmation/Hero_Entertainment.png';
const bethlehemHeroSalon = 'bethlehem/bethlehem_spa.jpg';
const bethlehemHeroChophouse = 'bethlehem/bethlehem_chophouse.jpg';
const sliderBethlehem1 = 'bethlehem/ChopHouse.png';
const sliderBethlehem2 = 'bethlehem/EventCenter1.png';
const sliderBethlehem3 = 'bethlehem/FishHouse1.png';
const sliderBethlehem4 = 'bethlehem/TheOutlets.png';
const sliderBethlehem5 = 'bethlehem/WCB_Coil.png';
const sliderBethlehem6 = 'bethlehem/WCB_KidsQuest.png';
const sliderBethlehem7 = 'bethlehem/WCB_Molten_v2.png';
const sliderBethlehem8 = 'bethlehem/WCB_SteelMagnolias2.png';
const sliderBethlehem9 = 'bethlehem/BuddyVs.png';

const chicagoDeluxeKing1 = 'chicago/Deluxe King/1.jpg';
const chicagoAccessibleKing1 = 'chicago/Accessible King/1.jpg';
const chicagoDeluxeQueen1 = 'chicago/Deluxe Queen/1.jpg';
const chicagoAccessibleQueen1 = 'chicago/Accessible Queen/1.jpg';
const chicagoExecutiveSuite1 = 'chicago/Executive Suite/1.jpg';
const chicagoAccessibleExecutiveSuite1 =
  'chicago/Accessible Executive Suite/1.jpg';
const chicagoFabulousSuite1 = 'chicago/Fabulous Suite/1.jpg';
const chicagoAccessibleFabulousSuite1 =
  'chicago/Accessible Fabulous Suite/1.jpg';
const chicagoFantasy1 = 'chicago/Fantasy Suite/1.jpg';
const chicagoAccessibleFantasy1 = 'chicago/Accessible Fantasy Suite/1.jpg';

export function addRoomImagePrefix(image) {
  return process.env.REACT_APP_ROOM_PHOTOS_URI + image;
}

export function addPropertyImagePrefix(image) {
  return process.env.REACT_APP_PROPERTY_PHOTOS_URI + image;
}

function addRoomImagePrefixesToMap(roomImageMap) {
  return mapValues(roomImageMap, function(images) {
    return images.map(addRoomImagePrefix);
  });
}

const CHICAGO_SLIDER_IMAGES = [
  sliderArcade,
  sliderBowling,
  sliderBuffet,
  sliderCinema,
  sliderGrill,
  sliderRVPark,
  sliderYoJoe
].map(addPropertyImagePrefix);

const CHICAGO_HERO_ITEMS = [
  {
    src: addPropertyImagePrefix(heroSpa),
    alt: 'Spa',
    header: 'SPA AT WIND CREEK',
    body:
      'Whether relaxing in a beautiful cascading whirlpool, melting away stress in one of our cedar saunas or awakening your senses in an ice bath, we have everything you need to be jealous of yourself.',
    hours: 'Mon-Sun, 6AM-8PM',
    phone: '(855) 393-7227'
  },
  {
    src: addPropertyImagePrefix(heroFire),
    alt: 'Fire',
    header: 'FIRE STEAKHOUSE',
    body:
      'Specializing in prime steaks, seafood and exceptional customer service, FIRE Steakhouse is incomparable to any dining in the region.',
    hours: 'Tue-Thu, 5PM-9PM; Fri-Sat, 5PM-10PM',
    phone: '(866) 946-3360'
  }
];

export const ATMORE_ROOM_IMAGES = addRoomImagePrefixesToMap({
  [DELUXE_KING]: [
    atmoreDeluxeKing1,
    atmoreDeluxeKing2,
    atmoreDeluxeKing3,
    atmoreDeluxeKing4,
    atmoreDeluxeKing5
  ],
  [DELUXE_QUEEN]: [atmoreDeluxeQueen1, atmoreDeluxeQueen2, atmoreDeluxeQueen3],
  [STANDARD_KING]: [
    atmoreDeluxeKing1,
    atmoreDeluxeKing2,
    atmoreDeluxeKing3,
    atmoreDeluxeKing4,
    atmoreDeluxeKing5
  ],
  [STANDARD_QUEEN]: [
    atmoreDeluxeQueen1,
    atmoreDeluxeQueen2,
    atmoreDeluxeQueen3
  ],
  [ULTRA_KING]: [
    atmoreUltraKing1,
    atmoreUltraKing2,
    atmoreUltraKing3,
    atmoreUltraKing4,
    atmoreUltraKing5
  ],
  [CORNER_SUITE]: [
    atmoreCornerSuite1,
    atmoreCornerSuite2,
    atmoreCornerSuite3,
    atmoreCornerSuite4,
    atmoreCornerSuite5,
    atmoreCornerSuite6,
    atmoreCornerSuite7,
    atmoreCornerSuite8,
    atmoreCornerSuite9,
    atmoreCornerSuite10,
    atmoreCornerSuite11,
    atmoreCornerSuite12
  ],
  [PLATINUM_SUITE]: [
    atmorePlatinumSuite1,
    atmorePlatinumSuite2,
    atmorePlatinumSuite3,
    atmorePlatinumSuite4,
    atmorePlatinumSuite5,
    atmorePlatinumSuite6,
    atmorePlatinumSuite7,
    atmorePlatinumSuite8,
    atmorePlatinumSuite9
  ]
});

export const BETHLEHEM_ROOM_IMAGES = addRoomImagePrefixesToMap({
  [DELUXE_KING]: [
    bethlehemDeluxeKing1,
    bethlehemDeluxeKing2,
    bethlehemDeluxeKing3
  ],
  [DELUXE_QUEEN]: [
    bethlehemDeluxeQueen1,
    bethlehemDeluxeQueen2,
    bethlehemDeluxeQueen3,
    bethlehemDeluxeQueen4
  ],
  [EXECUTIVE_SUITE]: [
    bethlehemExecutiveSuite1,
    bethlehemExecutiveSuite2,
    bethlehemExecutiveSuite3
  ],
  [PRESIDENTIAL_SUITE]: [
    bethlehemPresidentialSuite1,
    bethlehemPresidentialSuite2
  ],
  [CHAIRMAN_SUITE]: [
    bethlehemChairmanSuite1,
    bethlehemChairmanSuite2,
    bethlehemChairmanSuite3
  ]
});

export const BETHLEHEM_ROOM_IMAGES_TOWER_2 = addRoomImagePrefixesToMap({
  [DELUXE_KING]: [bethlehemTower2DeluxeKing1, bethlehemTower2DeluxeKing2],
  [DELUXE_QUEEN]: [bethlehemTower2DeluxeQueen1, bethlehemTower2DeluxeQueen2],
  [GRAND_KING]: [bethlehemTower2DeluxeKing1, bethlehemTower2DeluxeKing2],
  [EXECUTIVE_SUITE]: [
    bethlehemExecutiveSuite1,
    bethlehemExecutiveSuite2,
    bethlehemExecutiveSuite3
  ],
  [GRAND_EXECUTIVE_SUITE]: [
    bethlehemExecutiveSuite1,
    bethlehemExecutiveSuite2,
    bethlehemExecutiveSuite3
  ],
  [PRESIDENTIAL_SUITE]: [
    bethlehemPresidentialSuite1,
    bethlehemPresidentialSuite2
  ],
  [CHAIRMAN_SUITE]: [
    bethlehemChairmanSuite1,
    bethlehemChairmanSuite2,
    bethlehemChairmanSuite3
  ]
});

export const MONTGOMERY_ROOM_IMAGES = addRoomImagePrefixesToMap({
  [DELUXE_KING]: [montgomeryKing],
  [DELUXE_QUEEN]: [montgomeryDoubleQueen],
  [STANDARD_KING]: [montgomeryKing],
  [STANDARD_QUEEN]: [montgomeryDoubleQueen],
  [ULTRA_KING]: [montgomeryKing],
  [SUITE_KING]: [
    montgomerySuiteKing3,
    montgomerySuiteKing1,
    montgomerySuiteKing2
  ],
  [CORNER_SUITE]: [
    montgomerySuite1,
    montgomerySuite2,
    montgomerySuite3,
    montgomerySuite4,
    montgomerySuite5,
    montgomerySuite6
  ],
  [PLATINUM_SUITE]: [
    montgomerySuite1,
    montgomerySuite2,
    montgomerySuite3,
    montgomerySuite4,
    montgomerySuite5,
    montgomerySuite6
  ]
});

export const WETUMPKA_ROOM_IMAGES = addRoomImagePrefixesToMap({
  [DELUXE_KING]: [
    wetumpkaDeluxeKing1,
    wetumpkaDeluxeKing2,
    wetumpkaDeluxeKing3,
    wetumpkaDeluxeKing4,
    wetumpkaDeluxeKing5,
    wetumpkaDeluxeKing6,
    wetumpkaDeluxeKing7,
    wetumpkaDeluxeKing8,
    wetumpkaDeluxeKing9,
    wetumpkaDeluxeKing10,
    wetumpkaDeluxeKing11
  ],
  [DELUXE_QUEEN]: [
    wetumpkaDeluxeQueen1,
    wetumpkaDeluxeQueen2,
    wetumpkaDeluxeQueen3,
    wetumpkaDeluxeQueen4,
    wetumpkaDeluxeQueen5,
    wetumpkaDeluxeQueen6
  ],
  [STANDARD_KING]: [
    wetumpkaDeluxeKing1,
    wetumpkaDeluxeKing2,
    wetumpkaDeluxeKing3,
    wetumpkaDeluxeKing4,
    wetumpkaDeluxeKing5,
    wetumpkaDeluxeKing6,
    wetumpkaDeluxeKing7,
    wetumpkaDeluxeKing8,
    wetumpkaDeluxeKing9,
    wetumpkaDeluxeKing10,
    wetumpkaDeluxeKing11
  ],
  [STANDARD_QUEEN]: [
    wetumpkaDeluxeQueen1,
    wetumpkaDeluxeQueen2,
    wetumpkaDeluxeQueen3,
    wetumpkaDeluxeQueen4,
    wetumpkaDeluxeQueen5,
    wetumpkaDeluxeQueen6
  ],
  [ULTRA_KING]: [
    wetumpkaUltraKing1,
    wetumpkaUltraKing2,
    wetumpkaUltraKing3,
    wetumpkaUltraKing4,
    wetumpkaUltraKing5,
    wetumpkaUltraKing6,
    wetumpkaUltraKing7,
    wetumpkaUltraKing8,
    wetumpkaUltraKing9,
    wetumpkaUltraKing10,
    wetumpkaUltraKing11,
    wetumpkaUltraKing12,
    wetumpkaUltraKing13,
    wetumpkaUltraKing14,
    wetumpkaUltraKing15,
    wetumpkaUltraKing16
  ],
  [CORNER_SUITE]: [
    wetumpkaCornerSuite1,
    wetumpkaCornerSuite2,
    wetumpkaCornerSuite3,
    wetumpkaCornerSuite4,
    wetumpkaCornerSuite5,
    wetumpkaCornerSuite6,
    wetumpkaCornerSuite7
  ],
  [PLATINUM_SUITE]: [wetumpkaPlatinumSuite1]
});

export const CHICAGO_ROOM_IMAGES = addRoomImagePrefixesToMap({
  [DELUXE_KING]: [chicagoDeluxeKing1],
  [ACCESSIBLE_KING]: [chicagoAccessibleKing1],
  [DELUXE_QUEEN]: [chicagoDeluxeQueen1],
  [ACCESSIBLE_QUEEN]: [chicagoAccessibleQueen1],
  [EXECUTIVE_SUITE]: [chicagoExecutiveSuite1],
  [ACCESSIBLE_EXECUTIVE_SUITE]: [chicagoAccessibleExecutiveSuite1],
  [FABULOUS_SUITE]: [chicagoFabulousSuite1],
  [ACCESSIBLE_FABULOUS_SUITE]: [chicagoAccessibleFabulousSuite1],
  [FANTASY_SUITE]: [chicagoFantasy1],
  [ACCESSIBLE_FANTASY_SUITE]: [chicagoAccessibleFantasy1]
});

const ATMORE_SLIDER_IMAGES = [
  sliderArcade,
  sliderBowling,
  sliderBuffet,
  sliderCinema,
  sliderGrill,
  sliderRVPark,
  sliderYoJoe
].map(addPropertyImagePrefix);

const BETHLEHEM_SLIDER_IMAGES = [
  sliderBethlehem1,
  sliderBethlehem2,
  sliderBethlehem3,
  sliderBethlehem4,
  sliderBethlehem5,
  sliderBethlehem6,
  sliderBethlehem7,
  sliderBethlehem8,
  sliderBethlehem9
].map(addPropertyImagePrefix);

const MONTGOMERY_SLIDER_IMAGES = [
  sliderBarber,
  sliderBBKings,
  sliderBBKingsMusic,
  sliderFitnessCenter,
  sliderLucilles
].map(addPropertyImagePrefix);

const WETUMPKA_SLIDER_IMAGES = [
  sliderBuffet,
  sliderChillyBean,
  sliderGrill,
  sliderGrillToGo
].map(addPropertyImagePrefix);

const ATMORE_HERO_ITEMS = [
  {
    src: addPropertyImagePrefix(heroSpa),
    alt: 'Spa',
    header: 'SPA AT WIND CREEK',
    body:
      'Whether relaxing in a beautiful cascading whirlpool, melting away stress in one of our cedar saunas or awakening your senses in an ice bath, we have everything you need to be jealous of yourself.',
    hours: 'Mon-Sun, 6AM-8PM',
    phone: '(855) 393-7227'
  },
  {
    src: addPropertyImagePrefix(heroFire),
    alt: 'Fire',
    header: 'FIRE STEAKHOUSE',
    body:
      'Specializing in prime steaks, seafood and exceptional customer service, FIRE Steakhouse is incomparable to any dining in the region.',
    hours: 'Tue-Thu, 5PM-9PM; Fri-Sat, 5PM-10PM',
    phone: '(866) 946-3360'
  }
];

const BETHLEHEM_HERO_ITEMS = [
  {
    src: addPropertyImagePrefix(bethlehemHeroSalon),
    alt: 'Spa',
    header: 'STEEL MAGNOLIA SPA & SALON',
    body:
      'Our professional staff is eager to provide our valued clients with the best professional facials and spa services available. All services are performed by highly trained licensed professionals who meet today’s high industry demands. Please relax and enjoy your spa experience!',
    hours: 'Sun-Thu, 10AM-7PM; Fri-Sat, 10AM-9PM',
    phone: '(610) 625-4040'
  },
  {
    src: addPropertyImagePrefix(bethlehemHeroChophouse),
    alt: 'Chop House',
    header: "EMERIL'S CHOP HOUSE",
    body:
      "Emeril's elegant and comfortable chop house evokes the feel of the classic American steakhouse, updated with modern finishes and a creative menu that goes beyond the usual steakhouse standards.",
    hours: 'Sun-Thu, 5PM-10PM; Fri-Sat, 5PM-11PM',
    phone: '(877) 726-3777'
  }
];

const MONTGOMERY_HERO_ITEMS = [
  {
    src: addPropertyImagePrefix(heroIttaBena),
    alt: 'Itta Bena',
    header: 'ITTA BENA',
    body:
      'For gourmet southern cuisine with a taste of Beale Street on the side, make a date with Itta Bena. From crab to shrimp and potatoes to grits, it all comes together perfectly when your plate hits the table.',
    hours: 'Wed, Thu, Sun, 5PM-10PM; Fri-Sat, 5PM-11PM',
    phone: '(334) 514-5129'
  },
  {
    src: addPropertyImagePrefix(heroSalon),
    alt: 'Golden Shears Salon',
    header: 'GOLDEN SHEARS SALON',
    body:
      'From hair and nail services to shampooing and styling, our dedicated staff of capable cosmetologists can do whatever it takes to get you lookin’ and feelin’ great.',
    hours: 'Mon-Sat, 9AM-7PM',
    phone: '(334) 514-2085'
  }
];

const WETUMPKA_HERO_ITEMS = [
  {
    src: addPropertyImagePrefix(heroFire),
    alt: 'Fire Steakhouse',
    header: 'FIRE STEAKHOUSE',
    body:
      'Specializing in prime steaks, seafood and exceptional customer service, FIRE Steakhouse is incomparable to any dining in the region.',
    hours: 'Tue-Thu, 5PM-9PM; Fri-Sat, 5PM-10PM',
    phone: '(866) 946-3360'
  },
  {
    src: addPropertyImagePrefix(heroEntertainment),
    alt: 'Entertainment Center',
    header: 'ENTERTAINMENT CENTER',
    body:
      'When it comes to big-name national acts, the Entertainment Center at Wind Creek Wetumpka is the place to be. From Big &amp; Rich and Charlie Wilson to Billy Currington and CeeLo Green, the talent is amazing and the venue offers everyone the best seat in the house no matter where you are!',
    hours: 'Mon-Sat, 9AM-7PM',
    phone: '(334) 514-2085'
  }
];

export function getRoomImages(property, roomType, roomTypeCode) {
  if (
    property === PROPERTY_BETHLEHEM &&
    WCB_TOWER_2_ROOM_TYPE_CODES.includes(roomTypeCode)
  ) {
    return BETHLEHEM_ROOM_IMAGES_TOWER_2[roomType];
  }

  return ROOM_IMAGES[property][roomType];
}

export const ROOM_IMAGES = {
  [PROPERTY_ATMORE]: ATMORE_ROOM_IMAGES,
  [PROPERTY_MONTGOMERY]: MONTGOMERY_ROOM_IMAGES,
  [PROPERTY_WETUMPKA]: WETUMPKA_ROOM_IMAGES,
  [PROPERTY_BETHLEHEM]: BETHLEHEM_ROOM_IMAGES,
  [PROPERTY_CHICAGO]: CHICAGO_ROOM_IMAGES
};

export const SLIDER_IMAGES = {
  [PROPERTY_ATMORE]: ATMORE_SLIDER_IMAGES,
  [PROPERTY_BETHLEHEM]: BETHLEHEM_SLIDER_IMAGES,
  [PROPERTY_MONTGOMERY]: MONTGOMERY_SLIDER_IMAGES,
  [PROPERTY_WETUMPKA]: WETUMPKA_SLIDER_IMAGES,
  [PROPERTY_CHICAGO]: CHICAGO_SLIDER_IMAGES
};

export const HERO_ITEMS = {
  [PROPERTY_ATMORE]: ATMORE_HERO_ITEMS,
  [PROPERTY_BETHLEHEM]: BETHLEHEM_HERO_ITEMS,
  [PROPERTY_MONTGOMERY]: MONTGOMERY_HERO_ITEMS,
  [PROPERTY_WETUMPKA]: WETUMPKA_HERO_ITEMS,
  [PROPERTY_CHICAGO]: CHICAGO_HERO_ITEMS
};
